<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <div class="
            mb-2
            d-flex
            align-items-center
            justify-content-between
          ">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>

          <div class="page-title-right">
            <div class="col-md text-right">
              <b-button v-b-modal.modal-lg variant="primary" @click="closeModal">
                <b>Nouveau</b>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="padding-bottom: 200px">
      <div class="col-md-12 text-right">
        <b-modal id="modal-lg" centered v-model="showModal" size="md" :title="modalTitle" title-class="font-18"
          hide-footer>
          <form @submit.prevent="onSubmit" v-if="!updating">
            <div class="row mt-3">
              <div class="col">
                <label>{{ $t("pages.workflow.form.title") }}</label>
                <input type="text" v-model.trim="forms.name" class="form-control" required autofocus />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12 text-left">
                <br />
                <button type="submit" v-if="this.isLoading === false" class="btn col-4 btn-primary mr-2">
                  {{ $t("pages.metadata.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
                <button type="button" class="btn btn-light" @click="closeModal" data-dismiss="modal">
                  {{ $t("pages.metadata.cancel") }}
                </button>
              </div>
            </div>
          </form>

          <form @submit.prevent="onSubmit" v-else>
            <div class="row mt-4">
              <div class="col">
                <label>{{ $t("pages.workflow.form.name") }} </label>
                <input type="text" v-model.trim="selectedItem.name" class="form-control" required />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-left">
                <hr />
                <button type="submit" v-if="this.isLoading === false" class="btn btn-primary mr-2">
                  {{ $t("pages.metadata.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <!-- {{ $t("pages.metadata.saving") }} -->
                </button>
                <button type="button" class="btn btn-light" @click="closeModal" data-dismiss="modal">
                  {{ $t("pages.metadata.cancel") }}
                </button>
              </div>
            </div>
          </form>
        </b-modal>
      </div>
      <div class="col-md-12">
        <div v-if="isLoadingData" class="mt-2">
          <b-skeleton-table :rows="8" :columns="3"></b-skeleton-table>
        </div>
        <div class="row" v-else-if="processes.length > 0">
          <div class="col-12 col-md-6 d-block d-lg-none"  v-for="(process, index) in pageOfItems" :key="index" :value="process">
            <b-card class="border">
              <b-dropdown class="card-drop float-right" variant="white" right toggle-class="p-0">
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-vertical font-size-18"></i>
                </template>
                <b-dropdown-item @click="$router.push({ path: `/workflows/show/${process.id}` })">
                  {{ $t("pages.workflow.form.details") }}
                </b-dropdown-item>
                <b-dropdown-item @click="$router.push({ path: `/workflows/${process.id}` })">
                  {{ $t("pages.workflow.form.setup") }}
                </b-dropdown-item>
                <b-dropdown-item @click="updateProcessModal(process)">
                  {{ $t("pages.workflow.form.rename") }}
                </b-dropdown-item>
                <b-dropdown-item @click="removeProcess(process)">
                  {{ $t("pages.workflow.form.delete") }}
                </b-dropdown-item>
              </b-dropdown>
              
              <b-card-title>
                {{ process.name }}
              </b-card-title>

              <b-card-text>
                <div v-if="process.is_active">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="process.is_active" @click="updateStatus(process.id)"
                      class="custom-control-input" :id="process.id" />
                    <label class="custom-control-label" :for="process.id">
                      <span>
                        Statut {{ $t("pages.users.active") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div v-else>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="process.is_active" @click="updateStatus(process.id)"
                      class="custom-control-input" :id="process.id" />
                    <label class="custom-control-label" :for="process.id">
                      <span>
                        Statut {{ $t("pages.users.inactive") }}
                      </span>
                    </label>
                  </div>
                </div>
              </b-card-text>

              <b-card-text class="small text-muted">{{ $d(new Date(process.created_at), "long") }}</b-card-text>
            </b-card>
          </div>
          <div class="col-12 d-none d-lg-table">
            <table class="table table-hover mt-2">
              <thead class="thead-light">
                <tr>
                  <th class="text-left">{{ $t("pages.roles.name") }}</th>
                  <th class="text-left">Date</th>
                  <th>Statut</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(process, index) in pageOfItems" :key="index" :value="process">
                  <td>{{ process.name }}</td>
                  <td>{{ $d(new Date(process.created_at), "long") }}</td>
                  <td>
                    <div v-if="process.is_active">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" v-model="process.is_active" @click="updateStatus(process.id)"
                          class="custom-control-input" :id="process.id" />
                        <label class="custom-control-label" :for="process.id">
                          <span>
                            {{ $t("pages.users.active") }}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div v-else>
                      <div class="custom-control custom-switch">
                        <input type="checkbox" v-model="process.is_active" @click="updateStatus(process.id)"
                          class="custom-control-input" :id="process.id" />
                        <label class="custom-control-label" :for="process.id">
                          <span>
                            {{ $t("pages.users.inactive") }}
                          </span>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>
                      <b-dropdown-item @click="$router.push({ path: `/workflows/show/${process.id}` })">
                        {{ $t("pages.workflow.form.details") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="$router.push({ path: `/workflows/${process.id}` })">
                        {{ $t("pages.workflow.form.setup") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="updateProcessModal(process)">
                        {{ $t("pages.workflow.form.rename") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="removeProcess(process)">
                        {{ $t("pages.workflow.form.delete") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center empty-state-container" v-else>
          <div class="row">
            <div class="col-md-3 mx-auto">
              <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
            </div>
          </div>
          <h4 class="text-center">Aucun processus</h4>
          <p class="mt-2">Vous n'avez aucun processus configuré</p>
        </div>
      </div>
      <div class="col-md-12">
        <div class="text-center">
          <jw-pagination :pageSize="pageSize" :items="processes" @changePage="onChangePage" :labels="labels"
            class="text-center"></jw-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
  page: {
    title: "Workflows",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    LottieAnimation,
  },
  data() {
    return {
      title: "menuitems.workflow.title",
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },

      bool: false,
      pageOfItems: [],
      pageSize: 8,
      isLoadingData: false,
      isLoading: false,
      showModal: false,
      updating: false,
      selectedItem: {},
      forms: {
        name: "",
      },
    };
  },
  computed: {
    ...mapState({
      processes: (state) => state.processes.processes,
    }),
    modalTitle() {
      return this.updating ? "Renommer" : "Nouveau processus";
    },
  },
  methods: {
    ...mapActions([
      "getProcesses",
      "createProcess",
      "updateProcess",
      "deleteProcess",
      "updateProcessStatus",
    ]),
    closeModal() {
      this.showModal = false;
      this.forms = {
        id: null,
        name: "",
      };
      this.updating = false;
      this.selectedItem = {
        id: null,
        name: "",
      };
    },
    updateProcessModal(process) {
      this.showModal = true;
      this.updating = true;
      this.selectedItem = {
        id: process.id,
        name: process.name,
      };
    },
    updateStatus(processId) {
      this.updateProcessStatus(processId)
        .then((response) => {
          if (response.status == 200) {
            this.$toasted.success(this.$t("pages.workflow.details.statusChanged"));
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toasted.error(this.$t("pages.unauthorized.error_0"));
          console.log(err);
        });
    },
    removeProcess(process) {
      if (this.$can("delete", "processes")) {
        this.$toasted.clear();
        this.$swal({
          text: this.$t("pages.workflow.swal") + ` ${process.name} ?`,
          confirmButtonColor: "#d33",
          confirmButtonText: this.$t("pages.users.delete"),
        }).then((result) => {
          if (result.value) {
            this.deleteProcess(process.id).catch(() => {
              this.$toasted.error( this.$t("pages.workflow.toasts.error"), {
                duration: 3000,
                position: "top-center",
              });
            });
          }
        });
      }
      else {
        this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
      }
    },
    onSubmit() {
      this.isLoading = true;
      if (this.updating) {
        if (this.$can("update", "processes")) {
          this.updateProcess(this.selectedItem)
            .then((response) => {
              if (response.status === 200) {
                this.isLoading = false;
                this.$toasted.success("Modification effectuée avec succès");
                this.closeModal();
              }
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.isLoading = false;
                this.$toasted.error("Veuillez remplir tous les champs ", {
                  duration: 3000,
                  position: "top-center",
                });
              } else {
                this.isLoading = false;
                this.$toasted.error("Erreur du serveur ", {
                  duration: 3000,
                  position: "top-center",
                });
              }
            });
        } else {
          this.isLoading = false;
          this.$toasted.error(
            "Vous n'etes pas autorisé à effectuer cette action",
            {
              duration: 4000,
              position: "top-center",
            }
          );
        }
      } else {
        if (this.$can("create", "processes")) {
          let formData = new FormData();
          formData.append("name", this.forms.name);
          this.createProcess(formData)
            .then((response) => {
              if (response.status === 201) {
                this.isLoading = false;
                this.$toasted.success("Ajout effectué avec succès");
                this.closeModal();
              }
            })
            .catch((error) => {
              if (error) {
                this.isLoading = true;
                this.$toasted.error("Ce nom existe déjà", {
                  duration: 3000,
                  position: "top-center",
                });
              } else {
                this.isLoading = false;
                this.$toasted.error(
                  "Une erreur est survenue, Veuillez réessayer SVP...",
                  {
                    duration: 3000,
                    position: "top-center",
                  }
                );
              }
            });
        } else {
          this.isLoading = false;
          this.$toasted.error(
            "Vous n'etes pas autorisé à effectuer cette action",
            {
              duration: 4000,
              position: "top-center",
            }
          );
        }
      }
    },
    resetModal() {
      this.forms = "";
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
  },
  created() {
    if (this.$can("list", "processes")) {
      this.isLoadingData = true;
      this.getProcesses().finally(() => {
        this.isLoadingData = false;
      });
    }
  },
};
</script>


